import axios from '@/plugins/axios';

export async function addOrganization(id){
    return await axios.post(`appeals/organizations/${id}/add`);
}

export async function list(organizationId, limit, offset){
    return await axios.post(`appeals/organizations/${organizationId}/list`, {
        limit,
        offset
    });
}